<script>
    import { fly } from "svelte/transition";
    import { SnippetCreatedModalStore } from "./SnippetCreatedModalStore";
    import { ActiveTopicStore, ActiveTopic } from "$/stores/extension/ActiveTopicStore";
    import { ServiceConsts } from "$/services/ServiceConsts";

    function handleClose() {
        SnippetCreatedModalStore.hide();
    }
    function openExtension() {
        chrome.runtime.sendMessage({ action: "openExtension" });
        SnippetCreatedModalStore.hide();
    }
    function openDashboard() {

        let url = `${ServiceConsts.DASHBOARD_URL}/#/${$SnippetCreatedModalStore.snippet.tenantId}`;

        // topic
        if($SnippetCreatedModalStore.snippet.topicId) {
            url += `/t/${$SnippetCreatedModalStore.snippet.topicId}` +
                   `/s/${$SnippetCreatedModalStore.snippet.id}`
        
        // inbox
        } else {
            url += `/inbox`;
        }

        window.open(url, '_blank');
        SnippetCreatedModalStore.hide();
    }
</script>

{#if $SnippetCreatedModalStore.show}
    <div class="modal-container" transition:fly>
        <div class="modal">
            <svg
                on:click={handleClose}
                class="close-btn"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                />
            </svg>
            <p class="modal-text">
                Snippet saved to <b
                    >{$ActiveTopic?.name || "Unknown Topic"}</b
                >
            </p>

            <div class="open-btn-container">
                <button class="open-btn" on:click={openDashboard}>Open</button>

                {#if false}
                    <!-- 
                        For now we'll be opening Dashboard instead of Extension because
                        it's a more straight-forward way to handle both Mobile and Desktop
                    -->
                    <button class="open-btn" on:click={openExtension}>Open</button>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    @import "../../main.css";

    .modal-container {
        @apply fixed z-max bottom-0 right-0 flex min-h-[80px] w-full max-w-[300px] p-4 !important;
    }

    .modal {
        @apply relative flex w-full flex-col gap-2 rounded-lg bg-black p-2 shadow-lg !important;
    }
    .close-btn {
        @apply absolute right-2 top-2 z-10 h-4 w-4 cursor-pointer text-white transition-all hover:scale-110 !important;
    }

    .open-btn-container {
        @apply mt-auto flex w-full flex-row items-center justify-end;
    }
    .modal-text {
        @apply reset pr-6 text-sm text-white !important;
    }
    .open-btn {
        @apply -mr-1 cursor-pointer self-end rounded-sm border-none bg-black px-2 py-1 text-sm text-white hover:bg-gray-800 !important;
    }
</style>
